import httpsV2 from '../../httpsV2'

export const getCurrentConfiguration = () => {
  return httpsV2.get('/middleware/configuration')
}

export const updateConfiguration = (data) => {
  return httpsV2.put('/middleware/configuration', data)
}
